import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import UserProfile from "../pages/user-Profile";
import AnimalSellerForm from "../components/SellerProfile/sellerProfileform";
import AddAnimalForm from "../components/SellerProfile/addanimalform";
import EditAnimalForm from "../components/SellerProfile/editanimalform";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../Redux/common/actions";
import cartActions from "../Redux/cart/actions";

import ToastMessage from "../common/toastMessage";
import DocListPage from "../components/AboutUs/OurDoctor/index";
import TeamListPage from "../components/AboutUs/OurTeam";
import OurTeam from "../components/AboutUs/OurTeam/index";
import LoginModal from "../components/modal/LoginModal";
import UserAddressModal from "../components/modal/userAddressModal";
import Blog from "../pages/blog";
import Cart from "../pages/cart";
import Checkout from "../pages/checkout";
import Home from "../pages/home";
import ProductDetails from "../pages/productDetails";
import Products from "../pages/products";
import Treatments from "../pages/treatments";
import Consultation from "../pages/consultation";
import VideoBlog from "../pages/videoBlog";
import LogoutModal from "../components/modal/logoutModal";
import CCAvenue from "../components/checkout/ccavenue";
import { useTranslation } from "react-i18next";

import UsertoSeller from "../components/SellerProfile/UsertoSeller";
import Sellingprofile from "../components/SellerProfile/Selling-profile";

import MarketplaceLiveStock from "../pages/marketplaceLiveStock";
import MarketplaceLiveStockSingle from "../pages/marketplaceLiveStockSingle";
import MarketplaceSeller from "../pages/marketplaceSeller";
import CheckoutResponse from "../components/checkout/checkoutResponse";
import MarketplaceOtherServices from "../pages/marketplaceOtherServices";
import PaymentFailed from "../components/checkout/paymentFailed";
import PaymentSuccess from "../components/checkout/paymentSuccessfull";
import ScrollToTop from "../utils/scrollToTop";
import CallFloatingBtn from "../common/callFloatingBtn";
import NotFound from "../common/notFound";
import Privacy from "../components/commonComponents/privacyPolicy/PrivacyPolicy";
import setAuthToken from "../utils/setAuthToken";
import TermsandCondition from "../components/commonComponents/TermsandCondition/TermsandCondition";
import MetaPixelTracker from "../utils/MetaPixelTracker";
import ViewCartBtn from "../common/viewCartBtn";
import Events from "../pages/Events";

const Routers = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const { showUserAddressModal } = useSelector((state) => state.commonReducer);

  if (localStorage.getItem("token")) {
    setAuthToken(`Bearer ${localStorage.getItem("token")}`);
  }


  useEffect(() => {
    if (!sessionStorage.getItem("YFLanguage")) {
      sessionStorage.setItem("YFLanguage", "en");
      i18n.changeLanguage("en");
      dispatch({ type: commonActions.CURRENT_LANGUAGE, payload: "en" });
    }
    dispatch({ type: commonActions.GET_WEBSITE_LANGUAGES });

  }, []);

  useEffect(() => {

    return () => {
      sessionStorage.removeItem("addtocart");
    };
  }, []);



  useEffect(() => {
    if (localStorage.getItem("token") && localStorage.getItem("auth_user")) {
      dispatch({
        type: cartActions.GET_CART_PRODUCT_LIST,
        payload: { id: localStorage.getItem("auth_user") },
      });
    }

  }, []);



  return (
    <>
      <LoginModal />
      {showUserAddressModal && <UserAddressModal />}
      <LogoutModal />
      <ToastMessage />
      <Router>
        <MetaPixelTracker />
        <ScrollToTop />
        <div className="floating-buttons-wrapper">
          <CallFloatingBtn />
          <ViewCartBtn />
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product-details" element={<ProductDetails />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment-gateway" element={<CCAvenue />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/videos" element={<VideoBlog />} />
          <Route path="/user-profile" element={<UserProfile />} />


          <Route path="/consultation" element={<Consultation />} />
          <Route path="/treatments" element={<Treatments />} />

          {/* MarketPlace */}
          <Route path="/ourdoctors" element={<DocListPage />} />
          <Route path="/ourteam" element={<OurTeam />} />
          <Route path="/events" element={<Events />} />


          {/*Animals */}
          <Route path="/Animals" element={<MarketplaceLiveStock />} />
          <Route
            path="/service-providers"
            element={<MarketplaceOtherServices />}
          />

          <Route path="/Seller-Reg" element={<AnimalSellerForm />} />
          <Route path="/Animal-add" element={<AddAnimalForm />} />
          <Route path="/user-to-seller" element={<UsertoSeller />} />
          <Route path="/sellingprofile" element={<Sellingprofile />} />
          <Route path="/marketplace-seller" element={<MarketplaceSeller />} />
          <Route
            path="/marketplace-single"
            element={<MarketplaceLiveStockSingle />}
          />
          <Route path="/checkout-response" element={<CheckoutResponse />} />
          <Route path="/Animal-edit" element={<EditAnimalForm />} />
          <Route path="/PaymentFailed" element={<PaymentFailed />} />
          <Route path="/PaymentSuccess" element={<PaymentSuccess />} />
          <Route path="/privacy.html" element={<Privacy />} />
          <Route path="/termsandcondition" element={<TermsandCondition />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
};
export default Routers;
